import type { Mark } from "@tiptap/core"
import type { Mark as ProsemirrorMark, Schema } from "prosemirror-model"

import { ExtensionType } from "../../models"
import type { ExtendedRichTextNodeType } from "../../types"

export class LabelExtension {
  extType: ExtensionType.Mark = ExtensionType.Mark
  richTextNodeTypes: ExtendedRichTextNodeType[] = []
  constructor(
    readonly name: "label",
    readonly component: Mark,
    readonly converter: {
      fromPrismic(
        schema: Schema,
      ): (elmt: LabelElement) => ProsemirrorMark | undefined
      toPrismic(elmt: ProsemirrorMark): LabelElementData
    },
  ) {}
}

export interface LabelElement {
  type: "label"
  start: number
  end: number
  data: LabelElementData
}

export type LabelElementData = string
